// extracted by mini-css-extract-plugin
export default {"popup__title":"inactivityLogoutPopup_popup__title__nW38E","popup__text":"inactivityLogoutPopup_popup__text__iCWBB","popup__nextBtn":"inactivityLogoutPopup_popup__nextBtn__zB4iI"};